import { FormControl, Validators } from '@angular/forms';
import { ApplicationTypeParameterLogin } from '../../interfaces/application-type-param-login.interface';
import { ParameterType as ASParameterType } from '@asamco/management-portal/shared';
import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { ApplicationLogin } from '../../interfaces/application-login.interface';
import { ApplicationParams } from '../../interfaces/application-login-params.interface';

export class LinkEditApplicationLoginHelper {
	private parameterValidators: any[] = [];
	private leadingOrTrailingSpace: { [control: string]: boolean } = {};
	private switchIndex = 0;

	constructor(private formGroup, private applicationId: number, private appParams: ApplicationParams, private cdr: ChangeDetectorRef) {

	}

	public initializeParameterFormInitial() {
		this.initializeParameterForm(this.appParams.parameters);
	}

	private initializeParameterForm(parameters: Array<ApplicationTypeParameterLogin>) {
		this.parameterValidators.length = 0;

		for (let param of parameters) {
			const validators = [];
			if(param.underlyingElements && param.underlyingElements.length > 0)
			{
				this.switchIndex++;
				param.fieldName = 'Switchboxfield' + this.switchIndex;
			}

			if (param.isRequired) {
				validators.push(Validators.required);
			}
			if (param.type === ASParameterType.Email) {
				//	validators.push(Validators.email);
			}

			//The 'Name' field is a standard fillable field, but doesn't require validation/checking
			if(param.name !== 'Name')
			{
				this.parameterValidators.push(param.fieldName);
			}

			this.leadingOrTrailingSpace[param.fieldName] = false; // Initialize flag for each control
			if (param.defaultValue) {
			{
				this.formGroup.addControl(param.fieldName, new FormControl(param.defaultValue, { validators: validators })); //param.defaultValue
			}
			} else {
				this.formGroup.addControl(param.fieldName, new FormControl('', { validators: validators }));
			}

			//Resolve underlying elements
			if(param.underlyingElements)
			{
				this.initializeParameterForm(param.underlyingElements);

				this.formGroup.get(param.fieldName).valueChanges.pipe(distinctUntilChanged()).subscribe((value: boolean) => {
					//If we're displaying the underlying elements..
					if(value)
					{
						for(let element of param.underlyingElements)
						{
							this.formGroup.get(element.fieldName).enable();
						}
					}
					else
					{
						for(let element of param.underlyingElements)
						{
							this.formGroup.get(element.fieldName).disable();
						}
					}
					this.cdr.detectChanges();
				});
			}
		}
	}

	checkFormGroupForLeadingOrTrailingSpace() {
		this.parameterValidators.forEach(controlName => {
			if(controlName)
			{
				this.formGroup.get(controlName).valueChanges.subscribe(value => {
				  if (typeof value === 'string') {
					const trimmedValue = value.trim();
					this.leadingOrTrailingSpace[controlName] = value !== trimmedValue || (trimmedValue === '' && value !== '');
				  } else {
					this.leadingOrTrailingSpace[controlName] = false;
				  }
				});
			}
		  });
	}

	public setLogin(login: ApplicationLogin): void {
		if (login && this.formGroup) {
			// tslint:disable-next-line:forin
			for (const controlName in this.formGroup.controls) {
				//Case-insensitive search, since property search is otherwise always case-sensitive
				let value = this.getProperty(controlName, login);
				const controller = this.formGroup.get(controlName);

				if(controlName.includes('Switchboxfield'))
				{
					//check if the child entities of this entity not default, if so, enable the parent
					let underlyingElements = this.appParams.parameters.find(e => e.fieldName === controlName).underlyingElements;
					if(underlyingElements && underlyingElements.length > 0)
					{
						//we loop over the underlying elements, if one of them does not have a default value, we enable the parent
						let isFieldEnabled = false;
						underlyingElements.forEach(e => {
							let value = this.getProperty(e.fieldName, login);
							//let childValue = this.formGroup.get(e.fieldName).value;

							if(value != null && e.defaultValue != value)
							{
								isFieldEnabled = true;
							}
						});

						controller.setValue(isFieldEnabled);
					}
				}
				else
				{
					controller.setValue(value);
				}

			}

			this.formGroup.get('id').setValue(login.id);
			this.formGroup.get('applicationId').setValue(this.applicationId);
		} else if (this.formGroup) {
			this.formGroup.reset();
			//Reset values to default applicationparams
			this.appParams.parameters.forEach(e => {
				let field = this.formGroup.get(e.fieldName);
				if (field && e.defaultValue) {
					if(e.fieldName.includes('Switchboxfield'))
					{
						field.setValue(e.defaultValue.toLowerCase() === "true");
					}
					else
					{
						field.setValue(e.defaultValue);
					}

				}
			});

			this.formGroup.get('id').setValue(0);
			this.formGroup.get('applicationId').setValue(this.applicationId);
			this.formGroup.get('freshdeskArticleIds')?.setValue([]);
		}
	}

	getProperty(prop, obj) {
		prop = (prop + '').toLowerCase();
		for (const p in obj) {
			if (obj.hasOwnProperty(p) && prop === (p + '').toLowerCase()) {
				return obj[p];
			}
		}
	}
}
